import { render, staticRenderFns } from "./noti_menu.vue?vue&type=template&id=b5ed0d70&"
import script from "./noti_menu.vue?vue&type=script&lang=js&"
export * from "./noti_menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5ed0d70')) {
      api.createRecord('b5ed0d70', component.options)
    } else {
      api.reload('b5ed0d70', component.options)
    }
    module.hot.accept("./noti_menu.vue?vue&type=template&id=b5ed0d70&", function () {
      api.rerender('b5ed0d70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/notificacoes/noti_menu.vue"
export default component.exports